export default "__VITE_ASSET__BqQk6Q$C__"